import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcde12fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalShopList_Content" }
const _hoisted_2 = { class: "ModalShopList_Header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ModalShopList_Header_Title" }, "書店検索", -1))
const _hoisted_4 = { class: "ModalShopList_Main" }
const _hoisted_5 = { class: "ModalShopList_SearchContainer" }
const _hoisted_6 = { class: "ModalShopList_SearchForm" }
const _hoisted_7 = { class: "ModalShopList_SearchForm_Left" }
const _hoisted_8 = { class: "ModalShopList_SearchForm_Item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取次 :", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ModalShopList_SearchForm_List" }
const _hoisted_12 = { class: "ModalShopList_SearchForm_Item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取次書店CD :", -1))
const _hoisted_14 = { class: "ModalShopList_SearchForm_Item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "番線/作業CD :", -1))
const _hoisted_16 = { class: "ModalShopList_SearchForm_Item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "書店名称 :", -1))
const _hoisted_18 = { class: "paging_container" }
const _hoisted_19 = { class: "ModalShopList_TableContainer" }
const _hoisted_20 = { class: "ModalShopList_Table" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "選択"),
    /*#__PURE__*/_createElementVNode("th", null, "取次書店CD"),
    /*#__PURE__*/_createElementVNode("th", { class: "ModalShopList_Table_Syoten" }, "書店名"),
    /*#__PURE__*/_createElementVNode("th", null, "番線/作業CD"),
    /*#__PURE__*/_createElementVNode("th", null, "取次CD")
  ])
], -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "ModalShopList_Table_Syoten" }
const _hoisted_24 = {
  key: 0,
  class: "ResultMessageNull"
}

import { ref, reactive, onMounted, watch } from "vue";
import BtnGreenSmall from "../atoms/button/BtnGreenSmall.vue";
import BtnGreen from "../atoms/button/BtnGreen.vue";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";

interface SyotenData {
  heitenDate: null;
  heitenKbn: null;
  kousinDate: null;
  bansen: string;
  siyouKbn: string;
  syosiBansen: string;
  syosiBansenHojo: null;
  syotenCd: string;
  syotenMei: string;
  toritugiCd: string;
  toritugiSyotenCd: string;
  tourokuDate: null;
  vanDataKbn: string;
  zassiBansen: null;
  zassiBansenHojo: null;
}
interface Syoten {
  syotenMei: string;
  syotenCd: string;
  toritugiCd: string;
  toritugiSyotenCd: string;
  bansen: string;
}

//検索項目のリスト取得
//取次(「全件」項目を追加)

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalShopList',
  props: {
  toritugiCd: {
    type: [String, Object],
  },
},
  emits: ["close", "ref_selectSyoten", "input"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emit = __emit;
//propsの定義
// eslint-disable-next-line no-unused-vars
const props = __props;

//focus
const vFocus = {
  mounted: (el: HTMLElement) => el.focus(),
};

//検索条件設定用
// eslint-disable-next-line no-unused-vars
let searchConditions = reactive({
  toritugiCd: "",
  toritugiSyotenCd: "",
  syotenCd: "",
  bansen: "",
  syotenMei: "",
});
//検索条件の引継ぎ
const setInitialConditions = () => {
  searchConditions.toritugiCd = props.toritugiCd
    ? (props.toritugiCd as string)
    : "";
  store.commit("search/setSyotenDetailState", searchConditions);
};
setInitialConditions();

watch(searchConditions, () => {
  store.commit("search/setSyotenDetailState", searchConditions);
});
const inputToritugi = (e: string) => {
  searchConditions.toritugiCd = e;
};
// テーブル表示項目----------------------------------------------
const zenken = { toritugiCd: "", torihikisakiCd: "", toritugiMei: "全件" };
const toritugiList = [zenken, ...store.getters["constant/getToritugiList"]];

let search_result = ref<SyotenData[]>([]);

//モーダル開閉---------------------------
const closeModal = () => {
  emit("close");
};

//書店検索------------------------------
const onSearch = () => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  getSyotenData();
};
const getSyotenData = async (): Promise<void> => {
  search_result.value.splice(0);
  await store.dispatch("search/searchSyoten");
  const res = store.getters["search/getSyotenData"];
  res.syotenToritugiList.forEach((syoten: SyotenData) => {
    search_result.value.push(syoten);
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;

  getTotalPage();
};
onMounted(() => {
  onSearch();
});

//書店選択-------------------------------
const selectSyoten = (syoten: Syoten) => {
  if (window.confirm(`${syoten.syotenMei}を選択してもよろしいですか？`)) {
    emit("ref_selectSyoten", syoten);
    closeModal();
  }
};
// ページネーション関連処理---------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 50;
// 総ページ数
const numberOfTotalPage = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);

// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getSyotenData();
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "ModalShopList",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_font_awesome_icon, {
          onClick: closeModal,
          class: "ModalShopList_Header_Close",
          icon: "xmark"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchConditions).toritugiCd) = $event))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toritugiList, (option, index) => {
                    return _createElementVNode("option", {
                      value: option.toritugiCd,
                      key: index
                    }, _toDisplayString(option.toritugiMei), 9, _hoisted_10)
                  }), 64))
                ], 512), [
                  [_vModelSelect, _unref(searchConditions).toritugiCd]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ModalShopList_SearchForm_Input InputText",
                    placeholder: "取次/書店CDを入力",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchConditions).toritugiSyotenCd) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(searchConditions).toritugiSyotenCd],
                    [vFocus]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    class: "InputText ModalShopList_SearchForm_Input",
                    placeholder: "番線/作業CDを入力",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchConditions).bansen) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(searchConditions).bansen]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "InputText ModalShopList_SearchForm_Input",
                  placeholder: "書店名を入力",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchConditions).syotenMei) = $event))
                }, null, 512), [
                  [_vModelText, _unref(searchConditions).syotenMei]
                ])
              ])
            ])
          ]),
          _createVNode(BtnGreen, {
            class: "ModalShopList_BtnGreen",
            onClickBtn: onSearch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                class: "ModalShopList_SearchIcon",
                icon: "search"
              }),
              _createTextVNode(" 検索")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(Paginate), {
            "page-count": numberOfTotalPage.value,
            "hide-prev-next": true,
            "page-range": 3,
            "prev-text": '<',
            "next-text": '>',
            "container-class": 'pagination',
            "page-class": 'page-item',
            "page-link-class": 'page-item--link',
            "active-class": 'page-item--active',
            "click-handler": onClickPage,
            "force-page": currentPage.value
          }, null, 8, ["page-count", "force-page"]),
          _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
            [_vShow, _unref(search_result).length]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("table", _hoisted_20, [
            _hoisted_21,
            (_unref(search_result).length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createVNode(BtnGreenSmall, {
                          onClick: ($event: any) => (selectSyoten(result)),
                          class: "ModalShopList_BtnGreenSmall"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("選択")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(result.toritugiSyotenCd), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(result.syotenMei), 1),
                      _createElementVNode("td", null, _toDisplayString(result.bansen), 1),
                      _createElementVNode("td", null, _toDisplayString(result.toritugiCd), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_unref(search_result).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, " ※検索結果はありません "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})